import client from "../client";

export interface GetWinLostCommissionResponse {
  WinLost?: number;
  ProveComission?: number;
}

export default function API(): Promise<GetWinLostCommissionResponse> {
  return client
    .get(`members/get_win_lost_commission`)
    .then((response) => response.data)
    .then((json) => {
      return json;
    });
}
